import { useState } from "react";
import PropTypes from "prop-types";
import { ListTree, X } from "lucide-react";

import FieldTree from "./FieldTree";
import IconButton from "./IconButton";

const treeErrorCount = (items) => items.reduce(
  (total, item) => total + (item.errorCount || 0) + treeErrorCount(item.children || []),
  0,
);

const FormOutline = ({ activeId, items, onSelect }) => {
  const [open, setOpen] = useState(false);
  const errorCount = treeErrorCount(items);
  const select = (item) => {
    onSelect(item);
    setOpen(false);
  };

  return (
    <div className="wsm-form-outline">
      <button className="wsm-form-outline__trigger" onClick={() => setOpen(true)} type="button">
        <ListTree aria-hidden="true" />
        <span>Form tree</span>
        {errorCount > 0 && <strong>{errorCount}</strong>}
      </button>
      {open && <button aria-label="Close form tree" className="wsm-form-outline__scrim" onClick={() => setOpen(false)} type="button" />}
      <aside aria-label="Form tree" className={["wsm-form-outline__panel", open && "wsm-form-outline__panel--open"].filter(Boolean).join(" ")}>
        <div className="wsm-form-outline__mobile-heading">
          <strong>Form tree</strong>
          <IconButton aria-label="Close form tree" icon={X} onClick={() => setOpen(false)} size="compact" variant="ghost" />
        </div>
        <FieldTree activeId={activeId} description="Review sections and jump to a field." items={items} onSelect={select} />
      </aside>
    </div>
  );
};

FormOutline.propTypes = {
  activeId: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default FormOutline;
